
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teaching-home",
      function () {
        return require("private-next-pages/teaching-home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teaching-home"])
      });
    }
  